import { render, staticRenderFns } from "./adminRepairDetailList.vue?vue&type=template&id=356f532f&scoped=true"
import script from "./adminRepairDetailList.vue?vue&type=script&lang=js"
export * from "./adminRepairDetailList.vue?vue&type=script&lang=js"
import style0 from "./adminRepairDetailList.vue?vue&type=style&index=0&id=356f532f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356f532f",
  null
  
)

export default component.exports